import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class UserService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  find(query?: any) {
    return this.get('/v2/find-user', query);
  }

  list(query?: any) {
    return this.get('/v2/users', query);
  }

  create(body: any) {
    return this.post('/v2/create-user', body);
  }
  createUser(body: any) {
    return this.post('/create-user', body);
  }
  update(id, body) {
    return this.put('/v2/update-user/' + id, body);
  }
  active(id, body) {
    return this.put('/v2/active-user/' + id, body);
  }

  all(query?: any) {
    return this.get('/v2/all-user', query);
  }
  usersAllRole(query?: any) {
    return this.get('/v2/users-all-role', query);
  }

  resetPass(user_id, data) {
    return this.post('/v2/reset-password/' + user_id, data);
  }

  merge(data) {
    return this.post('/v2/user/merge', data);
  }
  updateCurentTime(data) {
    localStorage.removeItem('User');
    localStorage.setItem('User', JSON.stringify(data));
  }
  generateAgentId(query?: any) {
    return this.get('/v2/user/generate-agent-id', query);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/User.service.ts